export default __webpack_public_path__ + "static/media/avatarA3.c2ddeb61.png";